import component from './details-media.component'
import config from './details-media.config'

const module = angular.module('mpa.pages.details.media', [])

module.config(config).component('detailsMediaPageComponent', component)

export default module.name
